import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { environment } from '../../environments/environment';

export interface StateMasterDto {
  id?: number;
  stateName: string;
  isActive: boolean;
}
export interface StateMaster extends StateMasterDto {
  id: number;
}

/** GetAll/GetById return PascalCase (Dapper dynamic) — map to the camelCase UI model. */
function mapState(x: any): StateMaster {
  return {
    id: x.Id ?? x.id,
    stateName: x.StateName ?? x.stateName ?? '',
    isActive: (x.IsActive ?? x.isActive) ?? true,
  };
}

function mapEnvelope(res: any) {
  if (Array.isArray(res?.data)) return { ...res, data: res.data.map(mapState) };
  if (res?.data && typeof res.data === 'object') return { ...res, data: mapState(res.data) };
  if (Array.isArray(res)) return res.map(mapState);
  return res;
}

@Injectable({ providedIn: 'root' })
export class StateMasterService {
  private http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/StateMaster`;

  getAll() {
    return this.http.get(`${this.baseUrl}/GetAll`).pipe(map(mapEnvelope));
  }
  insert(dto: StateMasterDto) {
    return this.http.post(`${this.baseUrl}/Insert`, dto);
  }
  update(dto: StateMasterDto) {
    return this.http.post(`${this.baseUrl}/Update`, dto);
  }
  setActive(id: number, isActive: boolean) {
    return this.http.get(`${this.baseUrl}/SetActive`, { params: { id, isActive } });
  }
  delete(id: number) {
    return this.http.get(`${this.baseUrl}/Delete`, { params: { id } });
  }
}
